import { createContext, useContext, type ReactNode } from "react";

type PortalShellPreferences = {
  dark: boolean;
  setDark: (dark: boolean) => void;
};

const PortalShellPreferencesContext = createContext<PortalShellPreferences | null>(null);

export function PortalShellPreferencesProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: PortalShellPreferences;
}) {
  return (
    <PortalShellPreferencesContext.Provider value={value}>
      {children}
    </PortalShellPreferencesContext.Provider>
  );
}

export function usePortalShellPreferences() {
  return useContext(PortalShellPreferencesContext);
}
